import React from 'react';
import { ForgeAppLauncher, ForgeAppLauncherLink } from '@tylertech/forge-extended-react';
import { AppLauncherOption } from '@tylertech/forge-extended/app-launcher';
import _ from 'lodash';
import { IInternalLink } from '../navigation_drawer';
import { I18n } from 'common/i18n';

// #####################################################################
// ###### ⚠️⚠️⚠️⚠️⚠️ WARNING: APP LAUNCHER IS UNDER CONSTRUCTION ⚠️⚠️⚠️⚠️⚠️ ######
// #####################################################################
const scope = 'shared.site_chrome.forge_omnibar.app_launcher';

// ############# MOCK DATA #############
// We don't currently have a way to get the apps that a user has access to
// therefore we will mock some for now
const unrelatedAppsData = [
  { label: 'Cashiering', iconName: 'payment', uri: 'https://www.tylertech.com/' },
  { label: 'Enterprise Justice', iconName: 'account_balance', uri: 'https://www.tylertech.com/' },
  { label: 'Hub', iconName: 'dashboard', uri: 'https://www.tylertech.com/' },
  { label: 'Enterprise Assessment & Tax', iconName: 'calculate', uri: 'https://www.tylertech.com/' },
  { label: 'Enterprise Service Requests', iconName: 'report_problem', uri: 'https://www.tylertech.com/' },
  { label: 'Enterprise Permitting & Licensing', iconName: 'home_work', uri: 'https://www.tylertech.com/' },
] as AppLauncherOption[];

const relatedAppsData = [
  {
    label: 'Payments Administration',
    iconName: 'payment',
    uri: 'https://www.tylertech.com/',
    target: '_blank',
  },
  {
    label: 'PEP Administration',
    iconName: 'admin_panel_settings',
    uri: 'https://www.tylertech.com/',
    target: '_blank',
  },
  { label: 'Permissions', iconName: 'security', uri: 'https://www.tylertech.com/', target: '_blank' },
  {
    label: 'Batch Integration',
    iconName: 'batch_prediction',
    uri: 'https://www.tylertech.com/',
    target: '_blank',
  },
] as AppLauncherOption[];

const allAppsData = [...relatedAppsData, ...unrelatedAppsData];

// ############# END MOCK DATA #############

/**
 * Renders the application launcher UI. Work in process!!!
 * The intent is that this app launcher will eventually give users the ability to navigate to other Tyler applications they have access to.
 * Any internal links created in admin/site_appearance will also be displayed here.
 *
 * Currently behind feature flag: display_app_launcher
 *
 * @warning: This component is using placeholder values for the apps data until we have a way to get the actual apps a user has access to.
 * @warning: ForgeAppLauncher has a set english text for 'App Launcher' title, the forge component may need updating to support localization.
 */
export const AppLauncher = () => {
  const internalLinks: IInternalLink[] = _.get(window, 'socrata.siteChrome.internalLinks') || [];
  // Yeah for some reason these links can be missing some values so filtering any of those out.
  const validLinks = internalLinks.filter((link) => link && link.url && link.text);

  const internalLinksMenuTitle = _.get(window, 'socrata.siteChrome.internalLinksMenuTitle', '') as string;

  return (
    <ForgeAppLauncher allApps={allAppsData} relatedApps={relatedAppsData} data-testid="app-launcher">
      <span slot="related-apps-title">{I18n.t(`${scope}.related_apps`)}</span>
      <span slot="all-apps-title">{I18n.t(`${scope}.all_apps`)}</span>
      <span slot="view-all-apps-button-text">{I18n.t(`${scope}.view_all`)}</span>

      {validLinks.length && (
        <>
          <span slot="app-launcher-links-title">{internalLinksMenuTitle}</span>

          {validLinks.map((link, index: number) => (
            <ForgeAppLauncherLink key={index} slot="app-launcher-link">
              <a href={link.url} target="_blank">
                {link.text}
              </a>
            </ForgeAppLauncherLink>
          ))}
        </>
      )}
    </ForgeAppLauncher>
  );
};
